export const BACKGROUND_COLOR =
  "var(--adraw-background, light-dark(#fff, #000))"
export const FILL_COLOR = "var(--adraw-fill, transparent)"
export const SELECTION_COLOR =
  "var(--adraw-selection, light-dark(oklch(0.44 0.14 248), oklch(0.84 0.1 248)))"
export const STROKE_COLOR = "var(--adraw-stroke, light-dark(#000, #fff))"
export const STROKE_WIDTH = 2
